export default "/images/exclamation-lg.svg?134264951bf980950b56ffa063d8cb75";